import React from 'react';
import { useHotkeys } from '../../context/HotkeysContext';
import { CommandPalette } from './CommandPalette';
import { KeyboardShortcutsDialog } from './KeyboardShortcutsDialog';

/**
 * This component renders the command palette and keyboard shortcuts dialog.
 * It should be placed inside the HotkeysProvider.
 */
export const HotkeysIntegration: React.FC = () => {
  const {
    isCommandPaletteOpen,
    closeCommandPalette,
    isHelpDialogOpen,
    closeHelpDialog,
  } = useHotkeys();

  return (
    <>
      <CommandPalette open={isCommandPaletteOpen} onClose={closeCommandPalette} />
      <KeyboardShortcutsDialog open={isHelpDialogOpen} onClose={closeHelpDialog} />
    </>
  );
};

export default HotkeysIntegration;
